// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StepForwardFilledSvg from "@fishx/icons-svg/es/asn/StepForwardFilled";
import FishxIcon from '../components/FishxIcon';

var StepForwardFilled = function StepForwardFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StepForwardFilledSvg
  }));
};

StepForwardFilled.displayName = 'StepForwardFilled';
export default React.forwardRef(StepForwardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StepForwardFilled.js
// module id = 4189
// module chunks = 0